/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { FunctionComponent } from 'react';
import styles from '../../styles/profile/Tile01.module.css';

interface Tile01Props {
	/** icon image source */
	iconSrc: string;
	/** title text like "Badges" or "Certificates" */
	title: string;
	/** numeric value or text count */
	value: string | number;
	/** optional alt text for icon */
	altText?: string;
}

const Tile01: FunctionComponent<Tile01Props> = ({
	iconSrc,
	title,
	value,
	altText,
}) => {
	return (
		<div className={styles.tile01}>
			<div className={styles.vectorParent}>
				<img
					className={styles.vectorIcon}
					src={iconSrc}
					alt={altText || title}
				/>
				<div className={styles.badges}>{title}</div>
			</div>
			<div className={styles.div}>{value}</div>
		</div>
	);
};

export default Tile01;
